
<template>
  <Toast />
  <Card class="insights-card vocab-card">
    <template #title>
      <div class="card-title vocab-title">
        <i class="pi pi-book card-icon" />
        Vocabulary &amp; Grammar
      </div>
    </template>
    <template #content>
      <DataTable
        v-if="items.length"
        :value="items"
        striped-rows
        class="vocab-table"
      >
        <Column
          field="type"
          header="Type"
          style="width: 110px"
        >
          <template #body="{ data }">
            <Tag
              :value="data.type === 'vocabulary' ? 'Vocabulary' : 'Grammar'"
              :severity="data.type === 'vocabulary' ? 'info' : 'warning'"
              :class="data.type === 'vocabulary' ? 'vocab-tag' : 'grammar-tag'"
            />
          </template>
        </Column>
        <Column
          field="item"
          header="Item"
        >
          <template #body="{ data }">
            <span class="item-text">{{ data.item }}</span>
            <span
              v-if="data.reading"
              class="item-reading"
            >（{{ data.reading }}）</span>
          </template>
        </Column>
        <Column
          field="meaning"
          header="Meaning"
        />
        <Column
          header="Save"
          style="width: 100px"
        >
          <template #body="{ data, index }">
            <Button
              v-if="!savedWords[index]"
              icon="pi pi-bookmark"
              text
              :loading="savingWords[index]"
              class="save-word-btn"
              @click="saveWord(data, index)"
            />
            <Button
              v-else
              icon="pi pi-bookmark-fill"
              text
              disabled
              class="save-word-btn"
            />
          </template>
        </Column>
      </DataTable>
      <p
        v-else
        class="empty-state"
      >
        No vocabulary or grammar points recorded for this session.
      </p>
    </template>
  </Card>
</template>

<script>
import Card from 'primevue/card'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Tag from 'primevue/tag'
import Button from 'primevue/button'
import Toast from 'primevue/toast'
import { postWithAuthentication } from '@/services/api'
import { BASE_URL, SAVE_WORD_ENDPOINT } from '@/assets/constants/api_endpoints'

export default {
  name: 'InsightsVocabulary',
  components: { Card, DataTable, Column, Tag, Button, Toast },
  props: {
    items: {
      type: Array,
      required: true
    },
    subject: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      savingWords: {},
      savedWords: {}
    }
  },
  methods: {
    async saveWord(vocabulary, index) {
      this.savingWords = { ...this.savingWords, [index]: true }
      try {
          const payload = {
            word: vocabulary.item,
            definition: vocabulary.meaning || '',
            reading: vocabulary.reading || '',
            subject_id: this.subject,
            resource_id: "",
            jlpt: "",
            is_sample: false,
          }
          await postWithAuthentication(BASE_URL, SAVE_WORD_ENDPOINT, payload)
          this.savedWords = { ...this.savedWords, [index]: true }
          this.$toast.add({ 
            severity: 'success', 
            summary: 'Saved', 
            detail: 'Word added to your vocabulary list.', 
            life: 3000 
          })
      } catch (error) {
          this.$toast.add({ 
            severity: 'error', 
            summary: 'Error', 
            detail: 'Failed to save word. Please try again.', 
            life: 3000 
          })
      } finally {
        this.savingWords = { ...this.savingWords, [index]: false }
      }
    }
  }
}
</script>

<style scoped>
.insights-card {
  width: 100%;
  border-radius: 14px;
  border: 1.5px solid #a78bfa;
  box-shadow: 0 2px 10px rgba(139, 92, 246, 0.08);
  margin-bottom: 0;
  padding: 0;
}

.vocab-card {
  border-color: #a78bfa;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 1.08rem;
  font-weight: 700;
  color: #6d28d9;
  padding: 10px 0 0 0;
}

.vocab-title {
  color: #6d28d9;
}

.card-icon {
  color: #a78bfa;
  font-size: 1.2rem;
}

.vocab-table {
  font-size: 0.97rem;
  background: transparent;
  border: rgb(238, 230, 145) 0.5px solid;
  border-radius: 2px !important;
}

.vocab-tag {
  background: #ede9fe !important;
  color: #6d28d9 !important;
  border-radius: 8px !important;
  font-weight: 600;
}
.grammar-tag {
  background: #fef9c3 !important;
  color: #a16207 !important;
  border-radius: 8px !important;
  font-weight: 600;
}

.item-text {
  font-weight: 600;
}

.item-reading {
  margin-left: 4px;
  color: #7c3aed;
  font-size: 0.89rem;
}

.save-word-btn {
  padding: 0 !important;
}

.empty-state {
  margin: 0;
  color: #9ca3af;
  font-style: italic;
  font-size: 0.95rem;
}
</style>
